import React, { useState } from "react";
import { Button, Card, Space, Divider, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  HighSchoolCard,
  PrimarySchoolCard,
  UniversityCard,
} from "./EducationCards";
import useCommonsService from "../../../../services/useCommonsService";
import usePersonnelInfoService from "../../../../services/usePersonnelInfoService";
import EducationModal from "./EducationModal";

const EducationInfo = ({ personalEducation }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editItem, setEditItem] = useState({ data: null, type: null });

  const {
    useCompletionStatuses,
    useSchoolTypes,
    useGetAllEducationLanguages,
    useEducationTypes,
  } = useCommonsService();
  const { data: schoolTypes } = useSchoolTypes();
  const { data: completionStatuses } = useCompletionStatuses();
  const { data: educationLanguages } = useGetAllEducationLanguages();
  const { data: educationTypes } = useEducationTypes();

  console.log("schoolTypes: ", schoolTypes);

  const {
    useAddPersonnelEducation,
    useDeletePersonnelEducation,
    useUpdatePersonnelEducation,
  } = usePersonnelInfoService();
  const {
    mutateAsync: addPersonnelEducation,
    isPending: isAddPersonalEducationLoading,
  } = useAddPersonnelEducation();
  const {
    mutateAsync: deletePersonnelEducation,
    isPending: isDeletePersonalEducationLoading,
  } = useDeletePersonnelEducation();
  const {
    mutateAsync: updatePersonnelEducation,
    isPending: isUpdatePersonalEducationLoading,
  } = useUpdatePersonnelEducation();

  const categorizeEducations = (educations) => {
    return educations.reduce(
      (acc, education) => {
        const {
          schoolType: { name },
        } = education;
        if (name === "PRIMARY_SCHOOL") {
          acc.primarySchool.push(education);
        } else if (name === "HIGH_SCHOOL") {
          acc.highSchool.push(education);
        } else {
          acc.college.push(education);
        }
        return acc;
      },
      { primarySchool: [], highSchool: [], college: [] }
    );
  };
  const categorizedEducation = categorizeEducations(personalEducation);

  const handleSave = async (values) => {
    console.log("values are", values);

    const baseRequestBody = {
      schoolName: values.schoolName,
      schoolType: values.schoolType,
      completionStatus: values.isOngoing ? null : values.completionStatus,
      startMonth: values.startDate.$M + 1,
      startYear: values.startDate.$y,
      endMonth: values.isOngoing ? null : values.endDate.$M + 1,
      endYear: values.isOngoing ? null : values.endDate.$y,
    };

    let additionalFields = {};

    switch (values.schoolType || editItem?.type) {
      case "HIGH_SCHOOL":
        console.log("lisee");
        additionalFields = {
          educationLanguageId: values.educationLanguageId,
          description: values.description,
        };
        break;
      case "BACHELORS_DEGREE":
      case "MASTER":
      case "PHD":
        additionalFields = {
          educationLanguageId: values.educationLanguageId,
          faculty: values.faculty,
          department: values.department,
          educationType: values.educationType,
          gpa: values.gpa,
          description: values.description,
        };
        break;
    }

    const requestBody = {
      ...baseRequestBody,
      ...additionalFields,
    };

    try {
      await addPersonnelEducation(requestBody);
      setIsModalVisible(false);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const handleUpdate = async (values, id) => {
    console.log("values for edit", values);
    const baseRequestBody = {
      id,
      schoolName: values.schoolName,
      schoolType: values.schoolType,
      completionStatus: values.isOngoing ? null : values.completionStatus,
      startMonth: values.startDate.$M + 1,
      startYear: values.startDate.$y,
      endMonth: values.isOngoing ? null : values.endDate.$M + 1,
      endYear: values.isOngoing ? null : values.endDate.$y,
    };

    let additionalFields = {};

    switch (values.schoolType || editItem?.type) {
      case "HIGH_SCHOOL":
        additionalFields = {
          educationLanguageId: values.educationLanguageId,
          description: values.description,
        };
        break;
      case "BACHELORS_DEGREE":
      case "MASTER":
      case "PHD":
        additionalFields = {
          educationLanguageId: values.educationLanguageId,
          faculty: values.faculty,
          department: values.department,
          educationType: values.educationType,
          gpa: values.gpa,
          description: values.description,
        };
        break;
    }

    const requestBody = {
      ...baseRequestBody,
      ...additionalFields,
    };

    try {
      await updatePersonnelEducation(requestBody);
      setEditItem({ type: null, data: null });
      setIsModalVisible(false);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const onEdit = (type, data) => {
    setIsModalVisible(true);
    setEditItem({ type, data });
  };

  return (
    <Spin
      spinning={
        isAddPersonalEducationLoading ||
        isDeletePersonalEducationLoading ||
        isUpdatePersonalEducationLoading
      }>
      <Card style={{ width: "100%", maxWidth: 800, margin: "auto" }}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setIsModalVisible(true)}
            style={{ width: "100%" }}>
            Eğitim Bilgisi Ekle
          </Button>

          <Divider style={{ margin: 0 }} dashed />

          {categorizedEducation?.college?.map((item) => (
            <UniversityCard
              key={item.id}
              school={item}
              onDelete={deletePersonnelEducation}
              onEdit={onEdit}
            />
          ))}
          {categorizedEducation?.highSchool.map((item) => (
            <HighSchoolCard
              key={item.id}
              school={item}
              onDelete={deletePersonnelEducation}
              onEdit={onEdit}
            />
          ))}
          {categorizedEducation?.primarySchool.map((item) => (
            <PrimarySchoolCard
              key={item.id}
              school={item}
              onDelete={deletePersonnelEducation}
              onEdit={onEdit}
            />
          ))}
        </Space>

        <EducationModal
          visible={isModalVisible}
          onCancel={() => {
            setIsModalVisible(false);
            setEditItem({ type: null, data: null });
          }}
          onSave={handleSave}
          onEdit={handleUpdate}
          completionStatuses={completionStatuses}
          educationLanguages={educationLanguages}
          educationTypes={educationTypes}
          schoolTypes={schoolTypes}
          initialValues={editItem}
          isSubmitting={
            isAddPersonalEducationLoading || isUpdatePersonalEducationLoading
          }
        />
      </Card>
    </Spin>
  );
};

export default EducationInfo;
